import { YesNoCodesEnum } from 'app/bff/enums/yesNo';

export interface MemberLoginModalProps {
  visible: boolean;
}

/** 登入模式 */
export enum LoginModesEnum {
  /** 手機驗證登入 */
  Mobile = 'mobile',
  /** 密碼登入 */
  PassPhrase = 'passPhrase'
}

/** 手機驗證登入 (Step-1) 表單值 */
export interface MobileLoginFormValues {
  memberId: string;
  captchaCode: string;
  euMark: YesNoCodesEnum;
}

/** 手機驗證登入 (Step-2) 表單值 */
export interface MobileLoginOTPAuthFormValues {
  otpCode: string;
}

/** 手機驗證登入流程步驟代碼 */
export enum MobileLoginProcessStepCodesEnum {
  /** 手機驗證登入 (Step-1) */
  Login = '1',
  /** 手機驗證登入 (Step-2) */
  OTPAuth = '2'
}

/** 密碼登入表單值 */
export interface PassPhraseLoginFormValues {
  memberId: string;
  passPhrase: string;
  captchaCode: string;
  euMark: YesNoCodesEnum;
}
